/**
 * Labstep
 *
 * @module components/Metadata/Thread/Detail
 * @desc Metadata Thread Detail
 */

import { MetadataCardPreview } from 'labstep-web/components/Metadata/Card/Preview';
import { ThreadModal } from 'labstep-web/components/Thread/Modal';
import { Comment } from 'labstep-web/models/comment.model';
import type React from 'react';
import type { MetadataThreadDetailProps } from './types';

export const MetadataThreadDetail: React.FC<
  MetadataThreadDetailProps
> = ({ metadata }) => (
  <ThreadModal
    threadId={metadata.thread!.id}
    top={<MetadataCardPreview metadata={metadata} />}
    dividerChildren={`${metadata.thread!.comment_count} note(s)`}
    noCommentsMessage={`No ${Comment.getHumanReadableEntityName(
      true,
      true,
    )}`}
  />
);
